import { ILoginSession } from 'types/session';

import { REMOVE_LOGIN_SESSION, SET_LOGIN_SESSION, SET_LOGIN_FETCHING, SET_TPC_ENABLED } from './login.constants';
import { Actions } from 'modules/login/login.actions';

export interface IState {
    fetching: boolean;
    loginSession?: ILoginSession;
    hasTPCEnabled: boolean;
}

export const initialState: IState = {
    fetching: false,
    hasTPCEnabled: true
};

export const reducerKey = 'login' as const;

export const login = (state = initialState, action: Actions): IState => {
    switch (action.type) {
    case SET_LOGIN_FETCHING:
        return {
            ...state,
            fetching: action.payload
        };
    case SET_LOGIN_SESSION:
        return {
            ...state,
            loginSession: action.payload
        };
    case SET_TPC_ENABLED:
        return {
            ...state,
            hasTPCEnabled: action.payload
        };
    case REMOVE_LOGIN_SESSION:
        return initialState;
    default:
        return state;
    }
};

export default login;
